import { Link, RouteComponentProps } from '@reach/router'
import { Layout } from 'antd'
import React, { createContext, useReducer } from 'react'
import styled from 'styled-components'
import { RegisterForm } from '../components'
import { Brand } from '../components/ui/Brand'
import { MobileRegisterStep, RegisterStep } from '../components/ui/RegisterStep'
import { BreakingWidth, ColorPrimary } from '../components/ui/var'
import hero from '../assets/hero.jpg'
import { ROOT_PATH } from '../common/config'

const { Content } = Layout
const StyledRegister = styled.div`
  .page {
    display: flex;
    flex-direction: row;
    height: calc(var(--vh) * 100);
  }
  .page-left {
    background: linear-gradient(rgba(77, 70, 70, 0.3), rgba(77, 70, 70, 0.3)), url(${hero}) no-repeat center / cover;
    h1 {
      font-size: 28px;
    }
    @media (min-width: ${BreakingWidth.lg}) {
      width: 55%;
    }
  }
  .page-center {
    @media (min-width: ${BreakingWidth.lg}) {
      width: 28%;
      background-color: ${ColorPrimary};
      text-align: center;
    }
  }
  .page-content {
    flex: 1 !important;
    height: calc(var(--vh) * 100);
    /* overflow: scroll; */
    background-color: #f9bb19;
  }
`
const LeftSider = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  padding: 50px 0 20px;

  h1 {
    margin: 20px 0 10px;
    font-weight: 700;
    font-size: 26px;
  }
  p {
    margin-bottom: 40px;
    font-weight: 400;
    font-size: 16px;
  }
`

const VerticalAlign = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-direction: column;
  width: 100%;
  height: 100%;
  min-width: 400px;
`

export enum RStep {
  /** step 1 */
  EnterNumber = 0,
  /** step 2 */
  Agreement,
  /** step 3 */
  OTPCheck,
  /** step 4 */
  CreateUserName,
  /** step 5 */
  CreatePassword,
  /** step 6 */
  ChoosePhrase,
}
interface RegisterState {
  step: RStep
  /**
   * Loan Account Number
   */
  ano: string
  // 用户User ID
  usrId: string
  // 头像
  image: string
  // 密码（8-20）
  pwd: string
  // 注册请求流水号
  regId: string
  // security phrase
  scrt: string
  email: string
}

type LoginAction = { type: 'ChangeStep'; payload: RStep } | { type: 'ApplyForm'; payload: Partial<RegisterState> }

export const RegisterContext = createContext({ state: {} as RegisterState, dispatch: {} as React.Dispatch<LoginAction> })
const useLogin = () => {
  const initialState: RegisterState = {
    step: RStep.EnterNumber,
    // step: RStep.ChoosePhrase,
    ano: '',
    regId: '',
    // 用户User ID
    usrId: '',
    // 头像
    image: '',
    // 密码（8-20）
    pwd: '',
    // security phrase
    scrt: '',
    email: '',
  }
  const reducer = (state: RegisterState, action: LoginAction): RegisterState => {
    switch (action.type) {
      case 'ChangeStep':
        return { ...state, step: action.payload }
      case 'ApplyForm':
        return { ...state, ...action.payload }
      default:
        return state
    }
  }
  const [state, dispatch] = useReducer(reducer, initialState)
  return {
    state,
    dispatch,
  }
}

const RegisterProvider: React.FC = (props) => {
  const { state, dispatch } = useLogin()
  return <RegisterContext.Provider value={{ state, dispatch }}>{props.children}</RegisterContext.Provider>
}

export const Register: React.FC<RouteComponentProps> = () => {
  return (
    <StyledRegister>
      <RegisterProvider>
        <Layout className="page h-mscreen overflow-hidden">
          <Link className="hidden sm:block" to={ROOT_PATH}>
            <Brand className="absolute bg-white top-0 left-10 p-5" />
          </Link>
          <div className="sm:hidden fixed top-0 left-0 right-0 p-2 z-10" style={{ background: '#f9bb19' }}>
            <Link className="sm:hidden" to={ROOT_PATH}>
              <Brand className="absolute bg-white top-0 left-10 p-5" />
            </Link>
            <h1 className="text-center block font-bold">
              Customer <br /> Portal Registration
            </h1>
            <div>
              <MobileRegisterStep />
            </div>
          </div>
          <div className="page-left hidden md:flex">
            <LeftSider className="bg-white bg-opacity-75 ml-auto text-black">
              <VerticalAlign>
                <h1 className="text-center">
                  Customer <br /> Portal Registration
                </h1>

                <p className="text-center">
                  Take control of your account <br /> in six simple steps.
                </p>
                <RegisterStep />
              </VerticalAlign>
            </LeftSider>
          </div>
          <Content className="page-content overflow-hidden">
            <RegisterForm />
          </Content>
        </Layout>
      </RegisterProvider>
    </StyledRegister>
  )
}
